import { render, staticRenderFns } from "./InputFormVer2.vue?vue&type=template&id=03a22a75&scoped=true&"
import script from "./InputFormVer2.vue?vue&type=script&lang=js&"
export * from "./InputFormVer2.vue?vue&type=script&lang=js&"
import style0 from "./InputFormVer2.vue?vue&type=style&index=0&id=03a22a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a22a75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
